import phonePrefixes from './phonePrefixes.json';

export type PhonePrefixRow = (typeof phonePrefixes)[number];

const rows: PhonePrefixRow[] = phonePrefixes;

export const findRuleByCountryCode = (countryCode?: string | null): PhonePrefixRow | undefined => {
  if (!countryCode) return undefined;
  const normalized = countryCode.trim().toUpperCase();
  return rows.find(row => row.code === normalized);
};

/** Strip spaces, parentheses, dots and hyphens; keeps leading + and digits. */
export const normalizePhoneInput = (value: unknown): string => {
  if (value === undefined || value === null) return '';
  const s = String(value).trim();
  if (!s) return '';
  return s.replace(/[\s().-]/g, '');
};

export const findRuleByDialPrefix = (normalized: string): PhonePrefixRow | undefined => {
  const sorted = [...rows].sort((a, b) => b.dial_code.length - a.dial_code.length);
  return sorted.find(r => normalized.startsWith(r.dial_code));
};

export type PhonePrefixValidationFailure = 'empty' | 'format' | 'unknown_prefix' | 'length';

/** Validate using the longest matching dial_code in phonePrefixes (same idea as PhoneInput). */
export const validatePhoneByInferredPrefix = (
  normalized: string,
):
  | { ok: true }
  | { ok: false; reason: PhonePrefixValidationFailure } => {
  if (!normalized) return { ok: false, reason: 'empty' };
  if (!/^\+\d+$/.test(normalized)) return { ok: false, reason: 'format' };

  const rule = findRuleByDialPrefix(normalized);
  if (!rule) return { ok: false, reason: 'unknown_prefix' };

  const national = normalized.slice(rule.dial_code.length);
  if (!/^\d+$/.test(national)) return { ok: false, reason: 'format' };

  if (
    national.length < rule.national_min_digits ||
    national.length > rule.national_max_digits
  ) {
    return { ok: false, reason: 'length' };
  }

  return { ok: true };
};
